'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { cn } from '../../utils/cn';
import { scrollContainerStyles } from './TableView.styles';
export const TableView = ({ children, hasBorders, labelledBy, describedBy, className, }) => {
    const tableRef = useRef(null);
    const [overflowing, setOverflowing] = useState();
    const handleScroll = (e) => {
        const target = e.target;
        const maxScrollLeft = target.scrollWidth - target.clientWidth;
        if (maxScrollLeft === 0)
            return;
        if (target.scrollLeft === 0)
            return setOverflowing('right');
        if (target.scrollLeft === maxScrollLeft)
            return setOverflowing('left');
        if (target.scrollLeft > 0)
            return setOverflowing('both');
    };
    useEffect(() => {
        if (!tableRef.current)
            return;
        if (tableRef.current.scrollWidth > tableRef.current.clientWidth) {
            setOverflowing('right');
        }
    }, []);
    return (_jsx("div", { className: "overflow-hidden", children: _jsx("div", { className: scrollContainerStyles({ overflowing }), children: _jsx("div", { className: cn('overflow-scroll px-300', className), ref: tableRef, onScroll: handleScroll, children: _jsx("table", { "aria-labelledby": labelledBy, "aria-describedby": describedBy, className: cn('w-full', hasBorders && '[&>tbody>tr]:border-b-separators'), children: children }) }) }) }));
};
